import React from "react";
import messages from "../../images/messages.png";
import { FigmaImage } from "../../styledComponents";
export function Messages() {
  return <FigmaImage src={messages} />;
}
